import Vue from 'vue'
import vueInstance from "../../main"

const state = () => ({
  globalErrors: null,
  loaders: {},
  urlBackAfterLogin: null
})

const getters = {
  globalErrors: state => state.globalErrors,
  isLoading: state => {

    for (let key in state.loaders)
    {
      if (state.loaders[key]) {
        return true
      }
    }

    return false
  },
  urlBackAfterLogin: state => state.urlBackAfterLogin,
}

const mutations = {
  setGlobalErrors(state, globalErrors) {
      state.globalErrors = globalErrors
  },
  clearGlobalErrors(state) {
    if (!state.globalErrors) {
      return
    }

    let onClear = state.globalErrors.onClear
    state.globalErrors = null

    if (onClear) {
      onClear()
    }
},
  addLoader(state, loaderId) {
    Vue.set(state.loaders, loaderId, true)
  },
  removeLoader(state, loaderId) {
    Vue.delete(state.loaders, loaderId)
  },
  clearLoaders(state) {
    state.loaders = {}
  },
  setUrlBackAfterLogin(state, urlBackAfterLogin) {
    state.urlBackAfterLogin = urlBackAfterLogin
  },
  redirectAfterLogin(state) {
      let urlBackAfterLogin = state.urlBackAfterLogin
      state.urlBackAfterLogin = null

      vueInstance.$router.replace(urlBackAfterLogin || '/')
  }
}

const actions = {
  async setGlobalErrors({ commit }, globalErrors) {
    commit('setGlobalErrors', globalErrors)
  },
  async clearGlobalErrors({ commit }) {
    commit('clearGlobalErrors')
  },
  async addLoader({ commit }, loaderId) {
    commit('addLoader', loaderId)
  },
  async removeLoader({ commit }, loaderId) {
    commit('removeLoader', loaderId)
  },
  async clearLoaders({ commit }) {
    commit('clearLoaders')
  },
  async setUrlBackAfterLogin({ commit }, urlBackAfterLogin) {
    commit('setUrlBackAfterLogin', urlBackAfterLogin)
  },
  async redirectAfterLogin({ commit }) {
    commit('redirectAfterLogin')
  }
}

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state
}